import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITableFooterProps from "./type";
import {
    TableSectionContext,
    useTableContext
} from "../../context";
import type {
    TableSectionContextType
} from "../../type";

const TABLE_FOOTER_SECTION: TableSectionContextType = {
    section: "footer",
    isLast: true
};

const TableFooter: FC<ITableFooterProps> = ({
    children,
    style,
    ...props
}) => {
    const context = useTableContext({
        part: "Footer"
    });

    if(!context) {
        return null;
    }

    return <TableSectionContext.Provider
        value={TABLE_FOOTER_SECTION}
    >
        <View
            {...props}
            role="rowgroup"
            style={style}
        >
            {children}
        </View>
    </TableSectionContext.Provider>;
};
export default TableFooter;
